module.exports = __webpack_public_path__ + "img/user-transparent.4a96cc27.svg";